import React from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useState, useEffect, useRef } from "react";
import ValidatorService from "../../../../services/validator";
import AxiosWrapper from "../../../../services/axios";
import Wildcard from "../../../../services/wildcard";
import Parser from "react-html-parser";
import marketing from "../../../../services/marketing";
import ReactGA from "react-ga4";
import FacebookPixel from "react-fbq";
import applicantModel from "../../../../models/applicantModel";
import CreditProtection from "../../add-ons/CreditProtection";
import EConsent from "../../global-elements/eConsent";
import Acknowledgements from "../../add-ons/Acknowledgements";
import ConfirmSmsConsent from "../../global-elements/confirmsSmsConsent";
import TC from "../../add-ons/TC";
import Esign from "../../add-ons/esign";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import { tcGenerator } from "../../../../services/tcGenerator";
import SubmitApplicationService from "../../../../services/submitApplication";
import MfaSms from "../../global-elements/mfa/mfaSms";
import MfaEmail from "../../global-elements/mfa/mfaEmail";
import DeadEndMFa from "../../global-elements/mfa/deadEndMfa";
import AdobeScript from "../../../../services/adobeScript";
import { RESULTS } from "../../../../models/websiteTypesConstants";

function Offer() {

  const Setting = useStoreState((state) => state.siteSettingsModel);
  const info = useStoreState((state) => state.applicantModel.applicant);
  const applicationResult = useStoreState(
    (state) => state.applicationResultModel.applicationResult
  );
  const setApplicationResult = useStoreActions(
    (actions) => actions.applicationResultModel.setApplicationResult
  );
  const setInfo = useStoreActions(
    (actions) => actions.applicantModel.setApplicant
  );

  const text = useStoreState((state) => state.prequalText.termsStep);
  const assetsBaseUrl = useStoreState(
    (state) => state.siteSettingsModel.webAssetsBaseUrlSettings
  );
  const ApplicantApiClient = new AxiosWrapper();
  const Submit = SubmitApplicationService();
  const cardColors = useStoreState(
    (state) => state.siteSettingsModel.CardColors
  );


  const setCardColors = useStoreActions(
    (action) => action.siteSettingsModel.setCardColor
  );
  const applicantData = useStoreState(
    (state) => state.applicantModel.applicant
  );
  const setApplicantData = useStoreActions(
    (actions) => actions.applicantModel.setApplicant
  );
  const setCompleteApplicant = useStoreActions(
    (actions) => actions.applicantModel.setCompleteApplicant
  );
  const resultStep = useStoreActions((actions) => actions.setDisplayResult);
  const activeCheck = useStoreState((state) => state.siteSettingsModel.activateChecks);
  const applicantResult = useStoreState((state) => state.applicationResultModel.applicationResult);
  const MainPath = useStoreState((state) => state.siteSettingsModel.MainPath);
  const setMfaSms = useStoreActions(actions => actions.setMfaSms);
  const setFeature = useStoreActions(action => action.siteSettingsModel.overwriteWebsiteSettings);

  const {
    setError,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ shouldFocusError: true, mode: "onSubmit" });

  const [isLoading, setIsLoading] = useState(false);
  const [backendError, setBackendError] = useState("");
  const history = useHistory();
  const siteSetting = useStoreState((state) => state.siteSettingsModel);
  const isMounted = useRef(true);
  const methods = useForm({ shouldFocusError: false });
  const utm = new marketing();
  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const validatorService = new ValidatorService();
  const wildcard = new Wildcard();
  const adobe = new AdobeScript();

  const closeError = () => setErrorShow(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    //Google Pixels
    if (
      siteSetting.Pixels.find(
        (Pixel) => Pixel.Type === process.env.REACT_APP_GAFLAG
      )
    ) {
      ReactGA.send({ hitType: "pageview", page: "/step6terms" });
      ReactGA.event({ category: "tracking", action: "Terms", });
    }

    //Facebook Pixels
    if (siteSetting.Pixels.find((Pixel) => Pixel.Type === "Facebook")) {
      FacebookPixel.initialize({
        id: siteSetting.Pixels.find((Pixel) => Pixel.Type === "Facebook")[
          "Tag"
        ],
      });
      FacebookPixel.pageView();
    }

  }, []);

  useEffect(() => {
    if (!applicationResult.credit_limit) {
      history.push("/" + window.location.search);
    }
  }, []);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      setCompleteApplicant(applicantModel.applicant);
      event.preventDefault();
      history.push("/step1" + window.location.search);
    });
    
    window.afjref = () => {
      handleMfaChange(false);
    }
  }, []);

  useEffect(() => {
    if (isMounted.current && cardColors.length < 1) {
      ApplicantApiClient.post(
        "get-card-color-choice/", { productId: siteSetting.productSettings.ProductId, productCode: applicantData.ProductCode === "" ? applicationResult.product_code : applicantData.ProductCode }
      ).then((payload) => {
        if (payload) {
          if (payload.length > 0) {
            setCardColors(payload);
            setApplicantData({
              index: "cardColorCode",
              value: payload[0].Code,
            });
          }
        }
      });
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  
  function handleMfaChange(value){
    let temp = Setting.websiteSettings;

    if(value === false){
        temp =  Object.values(temp)
        temp = temp.filter(feature => feature.Name !== 'MFAActive');
        let result = {}

        temp.forEach((item, index) => {
            result[index] = item;
          });
        setFeature(result)
    }
  };

  const submit = async (fieldValueObject) => {
    setIsLoading(true);
    if (!validatorService.preValidations(fieldValueObject, methods, info)) {
       
      if(wildcard.isFeatureEnabled('MFAActive')){
        adobe.event('prequal_accept', Setting.CardColors.find(value => value.Code === info.cardColorCode))
        let mfaId = await ApplicantApiClient.get('/mfa-id',{})
        sessionStorage.setItem('mfaId', mfaId);
        let result = await ApplicantApiClient.post('/send-Mfa', {
            contactIdentifier : info.PrimaryPhone,
            contactType : 'Text', 
            ApplicantId : applicantResult.ref_number ,
            WebUrl : Setting.domain
            }, true)
        if(result && result.Success === true){
            sessionStorage.setItem('sessionToken', result.Payload)
            setMfaSms(true)
            return
        }
        setErrorShow(true);
        setErrorMessage('An unknown error has occured. Please try again.')
        return
      }else{
        await submitApp(fieldValueObject);
      }
  }

    setIsLoading(false);
  }

  const submitApp = async (data) => {

    const applicantResult = await Submit.submitApplicationOffer(info);
    const { decision } = applicantResult;
    if (applicantResult) {
      utm.updateSessionReport("appResultOffer", decision);
      switch(decision) {
        case RESULTS.PENDFEE: {
          window.scrollTo(0, 0);
          resultStep(true);
          history.push(MainPath + "pendfee" + window.location.search);
          break;
        }
        case RESULTS.APPROVED: {
          window.scrollTo(0, 0);
          resultStep(true);
          history.push(MainPath + "approvedmla" + window.location.search);
          break;
        } 
        case RESULTS.DECLINED: {
          window.scrollTo(0, 0);
          resultStep(true);
          history.push(MainPath + "decision" + window.location.search);
        }
        default: {
          setApplicationResult({ result: "DECLINED" });
          setBackendError("An unknown error has occured. Please try again.");
        }
      }
    } else {
      setBackendError("An unknown error has occured. Please try again.");
    }
  };



  return (
    <div className="container appFormsBackground terms">
      {/*--- MFA stuff ---*/}
      {(wildcard.isFeatureEnabled('MFAActive')) && (
        <>
          <MfaSms />
          <MfaEmail />
          <DeadEndMFa />
        </>

      )}
      {/*--- END MFA stuff ---*/}

      <ErrorModal
        size="sm"
        show={errorShow}
        message={errorMessage}
        closeError={closeError}
      />
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submit)}>

          <div className="">
            <p>
              You have been Pre-Approved for a {Setting.brandSettings.ProductName} Mastercard® with an initial credit limit of <b>${applicantResult.credit_limit}</b>.
            </p>
            <p><b>To complete your application, you must review the information below and press submit.</b></p>
            <p>
              -&nbsp;&nbsp;&nbsp;Applicant Disclosures <br />
              -&nbsp;&nbsp;&nbsp;Choose your card design, either standard or premium <br />
              -&nbsp;&nbsp;&nbsp;Optional Continental Credit Protection
            </p>
            <p>
              Then agree to the Acknowledgements and click the “Click here
              to sign and submit your application” below to complete your
              application.
            </p>
          </div>

          <div className="row">
            <div className="col-12">
              <h1 className="terms-header-title">E-Sign Disclosure</h1>
            </div>
            <Esign />
          </div>
          <div className="row">
            <div className="col-12">
              <h1 className="terms-header-title">Pricing and Terms</h1>
            </div>
            <div className="col-12 ">
              <div className="terms-wrapper">
                <TC
                  data={{ productCode: Setting.mainSettings.ProductCode }} onTermsErrorChange={setErrorMessage}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h1 className="terms-header-title">Credit Protection</h1>
            </div>
            <CreditProtection />
          </div>
          <div className="row">
            <div className="col-12">
              <h1 className="terms-header-title">Acknowledgements</h1>
            </div>
            <EConsent />
            {Setting.smsConcentModuleCFC === true && (
              <div className="col-12 mb-3">
                <div className="col-12">
                  <ConfirmSmsConsent></ConfirmSmsConsent>
                </div>
              </div>
            )}
            <Acknowledgements data={{ productCode: Setting.mainSettings.ProductCode }} />
          </div>
          <div className="form-group" style={{ display: "flex", justifyContent: "center" }}>
            <Button
              disabled={info.tcAcknowledgement !== "1"}
              className="pay-processing-button"
              type="submit"
              style={{
                marginTop: "1.5em",
                border: "1px solid transparent",
                color: "white",
                opacity: (info.tcAcknowledgement !== "1" || isLoading) ? 0.5 : 1,
              }}
              onClick={() => {
                adobe.event('form_submit');
              }}
            >
              {isLoading ? "Submitting..." : (wildcard.isFeatureEnabled('MFAActive') ? 'Verify and Submit' : "Submit Application")}
            </Button>
          </div>
          {backendError !== "" && (
            <div className="error-message"> {backendError} </div>
          )}
        </form>
      </FormProvider>
    </div>
  );
}

export default Offer;
